/**
 * 默认文案翻译表
 */
const defaultLanguageConf = {
  姓名: 'form.form_1001',
  地域: 'form.form_1002',
  邮箱: 'form.form_1003',
  公司: 'form.form_1054',
  性别: 'form.form_1055',
  职务: 'form.form_1056',
  手机: 'form.form_1064',
  地址: 'form.form_1085',
  手机号: 'account.account_1002',
  请输入姓名: 'interact_tools.interact_tools_1005',
  请输入手机号: 'account.account_1025',
  请输入信息: 'form.form_1106',
  请输入地址: 'interact_tools.interact_tools_1004',
  主持人发起了签到: 'interact_tools.interact_tools_1025',
  签到成功: 'interact_tools.interact_tools_1027',
  多谢大家支持: 'interact_tools.interact_tools_1032',
  文档: 'menu.menu_1001',
  简介: 'menu.menu_1003',
  章节: 'menu.menu_1013',
  聊天: 'menu.menu_1002',
  推荐: 'menu.menu_1005',
  商品: 'menu.menu_1004',
  文件下载: 'menu.menu_1016',
  精彩时刻: 'menu.menu_1018',
  概要总结: 'menu.menu_1019',
  回放列表: 'menu.menu_1020',
  AI直播纪要: 'menu.menu_1021',
  问答: 'menu.menu_1024',
  公告: 'interact_tools.interact_tools_1086',
  成员: 'aside_menu.aside_menu_1007',
  手机号格式有误: 'account.account_1050',
  免费: 'interact_tools.interact_tools_1058',
  咖啡: 'interact_tools.interact_tools_1059',
  爱心: 'interact_tools.interact_tools_1060',
  掌声: 'interact_tools.interact_tools_1075',
  鼓掌: 'interact_tools.interact_tools_1061',
  玫瑰: 'interact_tools.interact_tools_1062',
  火箭: 'interact_tools.interact_tools_1087',
  飞机: 'interact_tools.interact_tools_1088',
  礼炮: 'interact_tools.interact_tools_1089',
  汽车: 'interact_tools.interact_tools_1090',
  直播中回复: 'chat.chat_1039',
  凌晨: 'webinar.webinar_1027',
  早上: 'webinar.webinar_1028',
  下午: 'webinar.webinar_1029',
  晚上: 'webinar.webinar_1030',
  主持人: 'chat.chat_1022',
  嘉宾: 'chat.chat_1023',
  助理: 'chat.chat_1024',
  欺诈: 'feedback.feedback_1003',
  色情低俗: 'feedback.feedback_1004',
  血腥暴力: 'feedback.feedback_1005',
  传销: 'feedback.feedback_1006',
  邪教: 'feedback.feedback_1007',
  内容侵权: 'feedback.feedback_1008',
  违法犯罪: 'feedback.feedback_1009',
  其他问题: 'feedback.feedback_1010'
};
export default defaultLanguageConf;
